const documentsProducedAdditionalCategoryCode = [
    {
      "key": "DEFAULT",
      "value": "Please Select"
    },
    {
      "key": "A001",
      "value": "Certificate of authenticity fresh 'EMPEROR' table grapes.  EC Reg 1832/2002 amending Annex 1 to Council regulation 2658/87 on the tariff and statistical nomenclature and on the Common Customs Tariff."
    },
    {
      "key": "A004",
      "value": "Certificate of authenticity Tobacco.  EC Reg 1031/2008 amending Annex 1 to Council Regulation 2658/87."
    },
    {
      "key": "A007",
      "value": "Certificate of authenticity - Frozen beef and veal (crop, chuck and blade and brisket cuts). Commission Regulation (EEC) No 139/81 defining the conditions for the admission of certain kinds of frozen beef and veal to subheading 02.01 A II b) 4 bb) 22 of the Common Customs Tariff."
    },
    {
      "key": "A008",
      "value": "Certificate of authenticity fresh sweet oranges \"high quality\"."
    },
    {
      "key": "A009",
      "value": "Certificate of authenticity fresh minneola."
    },
    {
      "key": "A010",
      "value": "Certificate of authenticity concentrated orange juice."
    },
    {
      "key": "A014",
      "value": "Certificate of authenticity HANDI."
    },
    {
      "key": "A015",
      "value": "Certificate of authenticity (silk or cotton handloom products). See also document codes Y006 and Y007"
    },
    {
      "key": "A017",
      "value": "Certificate of authenticity as mentioned in Regulation (EU) No 593/2013 (OJ L 170) opening and providing for the administration of tariff quotas for high-quality fresh, chilled and frozen beef and for frozen buffalo meat."
    },
    {
      "key": "A019",
      "value": "Certificate of quality (Nitrate from Chile).  1001/13 amending Annex I to Council Regulation 2658/87."
    },
    {
      "key": "A022",
      "value": "Certificate of authenticity B \"Basmati Rice\" for export to the European Union.  EC Reg 972/2006 laying down special rules for imports of Basmati rice and a transitional control system for determining their origin."
    },
    {
      "key": "A023",
      "value": "Certificate of authenticity as mentioned in Regulation (EU) No 481/2012 (OJ L 148) laying down rules for the management of a tariff quota for high-quality beef."
    },
    {
      "key": "A030",
      "value": "Certificate of authenticity for export to the European Union � Fragrant rice.  Certificate of authenticity for export to the European Union � Fragrant rice\nEU Reg 2020/991 - Article 5 laying down the particulars of the required authenticity certificate, its use and validity. "
    },
    {
      "key": "C001",
      "value": "Attestation of equivalence as mentioned in Regulation (EC) No 1295/2008 (OJ L 340) on the importation of Hops from third countries. Products of the hops sector may be imported from third countries only if their quality standards are at least equivalent to those adopted for like products harvested within the Union or made from such products. Products shall be considered to be of the standard referred to in paragraph 1 if they are accompanied by an attestation issued by the authorities of the country of origin and recognised as equivalent to the certificate referred to in Article 77 of Regulation (EU) No. 704/2014."
    },
    {
      "key": "C008",
      "value": "Document issued by the competent authority or agency in the third country of origin, Implementing Regulation (EU) 2020/1988 repealing Regulation (EU) 1354/2011. Section 8 Article 31 of Implementing Regulation (EU) 2020/1988 Union tariff quotas for sheep, goats, sheepmeat and goatmeat."
    },
    {
      "key": "C013",
      "value": "Certificate IMA 1.  Milk and milk products: The New Zealand Food Safety Authority controls the quota through the issue of IMA1 certificates and these must be presented to the RPA to obtain an import licence.  See Notice 780 (CAP) for details."
    },
    {
      "key": "C014",
      "value": "V I 1 document.  EC REG 555/2008 laying down detailed rules for the application of Regulation (EC) 479/2008 of the relative Council, to the common organization of the wine market, with regard to support programs to trade with third countries production potential and controls in the wine sector."
    },
    {
      "key": "C015",
      "value": "V I 2 extract.  EC REG 555/2008 laying down detailed rules for the application of Regulation (EC) 479/2008 of the relative Council, to the common organization of the wine market, with regard to support programs to trade with third countries production potential and controls in the wine sector."
    },
    {
      "key": "C017",
      "value": "V I 1 document annotated in compliance with Commission Regulation (EU) 2018/273, Article 25(2)"
    },
    {
      "key": "C018",
      "value": "V I 2 extract annotated in compliance with Commission Regulation (EU) 2018/273, Article 25(2)"
    },
    {
      "key": "C019",
      "value": "OPO - Authorisation for the use of outward processing procedure (Column 8b, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "C026",
      "value": "Certificate of registration in a herdbook certifying the purity of the breed."
    },
    {
      "key": "C027",
      "value": "Pedigree certificate."
    },
    {
      "key": "C039",
      "value": "ICCAT swordfish statistical document. COUNCIL REGULATION (EC) No 1984/2003 establishing a system of statistical registration in the Union concerning bluefin tuna and swordfish and bigeye tuna."
    },
    {
      "key": "C040",
      "value": "ICCAT bigeye tuna statistical document or IOTC bigeye tuna statistical document. COUNCIL REGULATION (EC) No 1984/2003 establishing a system of statistical registration in the Union concerning bluefin tuna and swordfish and bigeye tuna."
    },
    {
      "key": "C041",
      "value": "ICCAT bluefin tuna re-export certificate (Reg 640/2010, L 194).  REGULATION (EU) No 640/2010 OF THE EUROPEAN PARLIAMENT AND OF THE COUNCIL establishing a catch documentation programme for bluefin tuna Thunnus thynnus and amending Council Regulation (EC) No 1984/2003."
    },
    {
      "key": "C042",
      "value": "ICCAT swordfish re-export certificate.  COUNCIL REGULATION (EC) No 1984/2003 establishing a system of statistical registration in the Union concerning bluefin tuna and swordfish and bigeye tuna."
    },
    {
      "key": "C043",
      "value": "ICCAT bigeye tuna re-export certificate or IOTC bigeye tuna re-export certificate. COUNCIL REGULATION (EC) No 1984/2003 establishing a system of statistical registration in the Union concerning bluefin tuna and swordfish and bigeye tuna"
    },
    {
      "key": "C046",
      "value": "Banana weighing certificate."
    },
    {
      "key": "C047",
      "value": "ICCAT Bluefin tuna catch document (BCD).  REGULATION (EU) No 640/2010 OF THE EUROPEAN PARLIAMENT AND OF THE COUNCIL establishing a catch documentation programme for bluefin tuna Thunnus thynnus and amending Council Regulation (EC) No 1984/2003."
    },
    {
      "key": "C050",
      "value": "Certificate as mentioned in the Regulation (EU) No. 1308/2013 (OJ L347). Certificate of quality for products of the hops sector, prohibiting the marketing of those products without a certificate as mentioned in Regulation (EU) No. 1308/2013 (OJ L347).  Certificates may be issued only for products having the minimum quality characteristics appropriate to a specific stage of marketing.  In the case of hop powder, hop powder with higher lupulin content, extract of hops and mixed hop products, the certificate may only be issued if the alpha acid content of these products is not lower than that of the hops from which they have been prepared. 3.   The certificates shall at least indicate:  (a) the place(s) of production of the hops; (b) the year(s) of harvesting; and (c) the variety or varieties. 4.   Products of the hops sector may be marketed or exported only if covered by a certificate issued in accordance with Article 77. Certificate as mentioned in the Regulation (EU) No. 1308/2013 (OJ L347).\nCertificate of quality for products of the hops sector, prohibiting the marketing of those products without a certificate as mentioned in Regulation (EU) No. 1308/2013 (OJ L347).\nCertificates may be issued only for products having the minimum quality characteristics appropriate to a specific stage of marketing.  In the case of hop powder, hop powder with higher lupulin content, extract of hops and mixed hop products, the certificate may only be issued if the alpha acid content of these products is not lower than that of the hops from which they have been prepared.\n3.   The certificates shall at least indicate:  \n(a) the place(s) of production of the hops; \n(b) the year(s) of harvesting; and\n(c) the variety or varieties.\n4.   Products of the hops sector may be marketed or exported only if covered by a certificate issued in accordance with Article 77.\nIn the case of imported products of the hops sector, the attestation provided for in Article 190(2) shall be deemed to be equivalent to that certificate (see C001)."
    },
    {
      "key": "C055",
      "value": "Declaration of compliance (Annex IV of Regulation (EU) No. 10/2011).  COMMISSION IMPLEMENTING REGULATION (EU) No 321/2011 amending Regulation (EU) No 10/2011 as regards the restriction of use of Bisphenol A in plastic infant feeding bottles"
    },
    {
      "key": "C056",
      "value": "Certificate concerning pelts of certain wild animal species and of goods incorporating such pelts subject to Council Regulation (EEC) No 3254/91."
    },
    {
      "key": "C057",
      "value": "Copy of the declaration of conformity � Option A, as referred in Article 1.2 and in the Annex of Regulation (EU) 2016/879.  Pursuant to Regulation (EU) 517/2014, for detailed arrangements relating to the declaration of conformity when placing refrigeration, air conditioning and heat pump equipment charged with hydrofluorocarbons on the market and its verification. A copy of the Certificate of Conformity as laid out in Annex 1 of Regulation (EU) 2016/879 must accompany the import declaration. See also document codes C079, C082 Y053, Y054, Y950 and Y951"
    },
    {
      "key": "C058",
      "value": "The statement of conformity with the end-of-waste criteria referred to in Article 5(1) of Council Regulation (EU) No 333/2011 is to be issued for each consignment of scrap metal ceased to be waste."
    },
    {
      "key": "C060",
      "value": "Declaration to be provided for every consignment of kitchenware falling under the provisions of (EU) Regulation 284/2011, originating in or consigned from the People�s Republic of China and Hong Kong Special Administrative Region, China. See also document code: Y046"
    },
    {
      "key": "C064",
      "value": "Authorisation for export or import of goods that could be used for torture (Regulation (EU) No 2019/125) concerning trade in certain goods which could be used for capital punishment, torture or other cruel, inhuman or degrading treatment or punishment. See  also C068, E990, Y904, Y906 and Y907"
    },
    {
      "key": "C065",
      "value": "Permit for invasive alien species in accordance with Art. 8 of Regulation (EU) 1143/2014 on the prevention and management of the introduction and spread of invasive alien species."
    },
    {
      "key": "C067",
      "value": "Import authorisation for restricted goods and technologies (Council Regulation (EU) No 267/2012) concerning restrictive measures against Iran and repealing Regulation (EU) No 961/2010."
    },
    {
      "key": "C071",
      "value": "Form for granting or denying written consent, pursuant to article 4(1) of Regulation (EU) 2017/852 of the European Parliament and of the Council on mercury, to the import of mercury or of the mixtures of mercury listed in Annex I to that Regulation."
    },
    {
      "key": "C072",
      "value": "Aircraft�s registration certificate in accordance with the Convention on International Civil Aviation dated 7 December 1944."
    },
    {
      "key": "C073",
      "value": "REACH Authorisation, according to Title VII of Regulation (EC) No 1907/2006 \nRegistration, Evaluation, Authorisation and Restriction of Chemicals (REACH) requires authorisations to be issued for the importation and placing on the home market of potentially harmful chemical substances See also document codes Y105, Y109 and Y115"
    },
    {
      "key": "C074",
      "value": "Zootechnical certificate (Regulation (EU) 2016/1012, Article 37) Purebred animals imported for breeding prposes shall be accompanied by: \n� the zootechnical certificate referred to in Article 30 (5) or Article 32 of Regulation (EU) 2016/1012; \n�  a document indicating that they are to be entered in a breeding book maintained by a breed society or registered in a breeding register maintained by a breeding operation. \nWhen declaring document code C074, document code C075 must also be declared"
    },
    {
      "key": "C075",
      "value": "Document indicating that purebred breeding animals are to be entered in a breeding book maintained by a breed society or registered in a breeding register maintained by a breeding operation (Regulation (EU) 2016/1012, Article 37) \nPurebred animals imported for breeding prposes shall be accompanied by: \n� the zootechnical certificate referred to in Article 30(5) or Article 32 of Regulation (EU) 2016/1012; \n� a document indicating that they are to be entered in a breeding book maintained by a breed society or registered in a breeding register maintained by a breeding operation\nWhen declaring document code C074, document code C075 must also be declared"
    },
    {
      "key": "C076",
      "value": "Authorisation issued by competent authority (Annex II, Part VI of Reg. (EU) 2017/1509) concerning restrictive measures against the Democratic People's Republic of Korea and repealing Regulation (EC) No 329/2007."
    },
    {
      "key": "C077",
      "value": "Authorisation issued by competent authority (Annex II, Part VIII of Reg. (EU) 2017/1509) concerning restrictive measures against the Democratic People's Republic of Korea and repealing Regulation (EC) No 329/2007."
    },
    {
      "key": "C078",
      "value": "Identification document for equidae (Regulation (EU) 2016/1012, Article 32) Purebred equine animals imported for breeding purposes may be accompanied by: \n� a single lifetime identification document for equine animls only \nWhen a single lifetime identification document is not held, document codes C074 and C075 must be declared instead"
    },
    {
      "key": "C079",
      "value": "Copy of the declaration of conformity - Option B, as referred to in Article 1.2 and in the Annex of Regulation (EU) 2016/879 Manufacture and importation of refrigeration, air conditioning and heat pump equipment containing hydrofluorocarbons. A copy of the Certificate of Conformity as laid out in Annex 1 of Regulation (EU) 2016/879 must accompany the import declaration. See also document codes C057, C082, Y053, Y054, Y950 and Y951"
    },
    {
      "key": "C080",
      "value": "Simplified V I 1 document.  EC REG 555/2008 laying down detailed rules for the application of Regulation (EC) 479/2008 of the relative Council, to the common organization of the wine market, with regard to support programs to trade with third countries production potential and controls in the wine sector."
    },
    {
      "key": "C081",
      "value": "Self-certification Simplified V I 1 document.  EC REG 555/2008 laying down detailed rules for the application of Regulation (EC) 479/2008 of the relative Council, to the common organization of the wine market, with regard to support programs to trade with third countries production potential and controls in the wine sector."
    },
    {
      "key": "C082",
      "value": "Copy of the declaration of conformity - Option C, as referred to in Article 1.2 and in the Annex of Regulation (EU) 2016/879 Manufacture and importation of refrigeration, air conditioning and heat pump equipment containing hydrofluorocarbons. A copy of the Certificate of Conformity as laid out in Annex 1 of Regulation (EU) 2016/879 must accompany the import declaration. See also document codes C057, C079, Y053, Y054, Y950 and Y951"
    },
    {
      "key": "C084",
      "value": "Exemption by virtue of Articles 3 and 4 of Commission Delegated Regulation (EU) 2019/2122 (Animals intended for scientific purposes, research and diagnostic samples). Certain categories of animals and goods that are exempted from official controls at border control posts as defined in Commission Delegated Regulation (EU) 2019/2122"
    },
    {
      "key": "C085",
      "value": "Common Health Entry Document for Plants and Plant Products (CHED-PP) (as set out in Part 2, Section C of Annex II to Commission Implementing Regulation (EU) 2019/1715 (OJ L 261)) The CHED-PP is to be used for the importation of � Plants, plant products and other objects referred to in points (c), (d), (e) or (f) of Article 47(1) of Regulation (EU) 2017/625; � Specific plants, plant products and other objects of a particular origin or provenance for which a minimum level of official controls is necessary to respond to recognised uniform hazards and risks to plant health as provided for in Implementing Regulation (EU) 2019/66."
    },
    {
      "key": "C100",
      "value": "Registered Exporter Number (REX).  EC Reg 2447/2015 of the UCC IA for \"Implementing Act\". This document code must be declared whenever a preference document code requiring a REX authorisation is declared"
    },
    {
      "key": "C119",
      "value": "Authorised Release Certificate � EASA Form 1 (Appendix I to Annex I to Regulation (EU) No 748/2012), or equivalent certificate Formerly referred to as: Airworthiness certificate "
    },
    {
      "key": "C400",
      "value": "Presentation of the required \"CITES\" certificate.  Commission Reg 160/2017 amending Council Reg (EC) No 338/97 on the protection of species of wild fauna and flora by regulating trade therein. See also Document Codes, C635, C638 and Y900"
    },
    {
      "key": "C402",
      "value": "CITES Export permit or Re-export certificate issued by a third country.  Commission Reg 2017/160 amending Council Reg (EC) No 338/97 on the protection of species of wild fauna and flora by regulating trade therein."
    },
    {
      "key": "C403",
      "value": "CITES Travelling exhibition certificate.  Commission Reg 2017/160 amending Council Reg (EC) No 338/97 on the protection of species of wild fauna and flora by regulating trade therein."
    },
    {
      "key": "C404",
      "value": "CITES Personal ownership certificate.  Commission Reg 2017/160 amending Council Reg (EC) No 338/97 on the protection of species of wild fauna and flora by regulating trade therein."
    },
    {
      "key": "C405",
      "value": "CITES Sample collection certificate.  Commission Reg 2017/160 amending Council Reg (EC) No 338/97 on the protection of species of wild fauna and flora by regulating trade therein."
    },
    {
      "key": "C406",
      "value": "CITES Musical instrument certificate.  Commission Reg 2017/160 amending Council Reg (EC) No 338/97 on the protection of species of wild fauna and flora by regulating trade therein."
    },
    {
      "key": "C501",
      "value": "AEOC - Authorisation for the status of Authorised Economic Operator - Customs Simplifications (Column 2, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "C502",
      "value": "AEOS - Authorisation for the status of Authorised Economic Operator � Security and safety (Column 2, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "C503",
      "value": "AEOF - Authorisation for the status of Authorised Economic Operator � Customs simplifications/Security and safety (Column 2, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "C504",
      "value": "CVA - Authorisation for the simplification of the determination of amounts being part of the customs value of goods (Column 3, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "C505",
      "value": "Where Comprehensive Guarantee is Required CGU - Authorisation for the provision of a comprehensive guarantee, including possible reduction or waiver (Column 4a, Annex A of Delegated Regulation (EU) 2015/2446).  (See following code for when a guarantee is not required)"
    },
    {
      "key": "C505",
      "value": "For cases where a comprehensive guarantee is not required (including deferment accounts, OGDs, Public Bodies, fixed energy installations and goods below the statistical threshold): CGU - Authorisation for the provision of a comprehensive guarantee, including possible reduction or waiver (Column 4a, Annex A of Delegated Regulation (EU) 2015/2446).  (see previous code for when a guarantee is required)"
    },
    {
      "key": "C506",
      "value": "DPO - Authorisation for the deferment of payment (Column 4b, Annex A of Delegated Regulation (EU) 2015/2446))."
    },
    {
      "key": "C507",
      "value": "REP - Decision for the repayment of the amounts of import or export duty, including C&E 1179 claims (Column 4c, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "C508",
      "value": "REM - Decision for the remission of the amounts of import or export duty (Column 4c, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "C509",
      "value": "TST - Authorisation for the operation of storage facilities for the temporary storage of goods (Column 5, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "C510",
      "value": "RSS - Authorisation to establish regular shipping services (Column 6a, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "C511",
      "value": "ACP - Authorisation for the status of authorised issuer to establish the proof of the customs status of Union goods (Column 6b, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "C512",
      "value": "SDE - Authorisation to use simplified declaration (Column 7a, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "C513",
      "value": "CCL - Authorisation for centralised clearance (Column 7b, Annex A of Delegated Regulation (EU) 2015/2446) including SASP."
    },
    {
      "key": "C514",
      "value": "EIR - Authorisation for making a customs declaration through an entry in the declarant's records, including for the export procedure (Column 7c, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "C515",
      "value": "SAS - Authorisation for self-assessment (Column 7d, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "C516",
      "value": "TEA/ TEAH - Authorisation for the use of temporary admission (Column 8d, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "C517",
      "value": "CWP - Authorisation for the operation of storage facilities for the customs warehousing of goods in a private customs warehouse (Column 8e, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "C518",
      "value": "CW1 - Authorisation for the operation of storage facilities for the customs warehousing of goods in a public customs warehouse type I (Column 8e, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "C519",
      "value": "CW2 - Authorisation for the operation of storage facilities for the customs warehousing of goods in a public customs warehouse type II (Column 8e, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "C520",
      "value": "ACT - Authorisation for the status of authorised consignee for TIR procedure (Column 9a, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "C521",
      "value": "ACR - Authorisation for the status of authorised consignor for Union transit (Column 9b, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "C522",
      "value": "ACE - Authorisation for the status of authorised consignee for Union transit (Column 9c, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "C523",
      "value": "SSE - Authorisation for the use of seals of a special type (Column 9d, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "C524",
      "value": "TRD - Authorisation to use transit declaration with a reduced dataset (Column 9e, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "C525",
      "value": "ETD - Authorisation for the use of an electronic transport document as customs declaration (Column 9f, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "C526",
      "value": "AWB - Authorisation for the status of authorised weigher of bananas (Column 7e, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "C600",
      "value": "Authorisation to operate a Free Zone"
    },
    {
      "key": "C601",
      "value": "IPO - Authorisation for the use of inward processing procedure (Column 8a, Annex A of Delegated regulation (EU) 2015/2446)."
    },
    {
      "key": "C602",
      "value": "Declaration of particulars relating to customs value (continuation sheet D.V.1BIS)."
    },
    {
      "key": "C603",
      "value": "Information sheet INF1 for inward processing (C&E1143)."
    },
    {
      "key": "C604",
      "value": "Information sheet INF2 for outward processing triangular traffic (C&E1155)."
    },
    {
      "key": "C605",
      "value": "Information sheet INF3 for returned goods (C&E1558)."
    },
    {
      "key": "C606",
      "value": "Information sheet INF5 for inward processing triangular traffic (EX/IM) (C&E1290)."
    },
    {
      "key": "C610",
      "value": "Information sheet INF9 relating to Inward processing triangular traffic (IM/EX)."
    },
    {
      "key": "C612",
      "value": "Internal Union transit declaration, T2F."
    },
    {
      "key": "C613",
      "value": "Consignment note CIM (T2)."
    },
    {
      "key": "C614",
      "value": "Consignment note CIM (T2F)."
    },
    {
      "key": "C615",
      "value": "TR transfer note (T1)."
    },
    {
      "key": "C616",
      "value": "TR transfer note (T2)."
    },
    {
      "key": "C617",
      "value": "TR transfer note (T2F)."
    },
    {
      "key": "C618",
      "value": "Air manifest (T2F)."
    },
    {
      "key": "C619",
      "value": "Maritime manifest (T2F)."
    },
    {
      "key": "C620",
      "value": "T2LF document."
    },
    {
      "key": "C621",
      "value": "Proof of customs status: fishing logbook, landing declaration, transhipment declaration or data from the vessel monitoring system, as stipulated in Article 199(1)(e) of Regulation (EU) 2015/2447."
    },
    {
      "key": "C622",
      "value": "Certificate of customs status."
    },
    {
      "key": "C623",
      "value": "Transhipment certificate EXP.1."
    },
    {
      "key": "C624",
      "value": "Form 302 "
    },
    {
      "key": "C625",
      "value": "Rhine Manifest."
    },
    {
      "key": "C626",
      "value": "BTI - Decision relating to Binding Tariff Information (Column 1a, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "C627",
      "value": "BOI - Decision relating to Binding Origin Information (Column 1b, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "C631",
      "value": "Formal letter validating the use of non-wooden or recycled materials for paper products, issued by the Ministry of Industry of the FLEGT VPA partner country from which the paper products are originating.  "
    },
    {
      "key": "C635",
      "value": "CITES Label for Scientific Material.  Commission Reg 160/2017 on the protection of species of wild fauna and flora by regulating trade therein. Please note that this code is not currently mandated for CITES measures. See documents codes C400 and Y900."
    },
    {
      "key": "C638",
      "value": "CITES Import or Export permit.  Commission Reg 160/2017 on the protection of species of wild fauna and flora by regulating trade therein. Please note that this code is not currently mandated for CITES measures. See documents codes C400 and Y900."
    },
    {
      "key": "C639",
      "value": "CITES Import or export notification.  Commission Reg 160/2017 on the protection of species of wild fauna and flora by regulating trade therein."
    },
    {
      "key": "C640",
      "value": "Common Health Entry Document for Animals (CHED-A) (as set out in Part 2, Section A of Annex II to Commission Implementing Regulation (EU) 2019/1715 (OJ L 261)), used for animals referred to in point (a) of Article 47(1) of Regulation (EU) 2017/625)"
    },
    {
      "key": "C641",
      "value": "Dissostichus - catch document import.  COUNCIL REGULATION (EC) No 1368/2006 establishing a catch documentation scheme for Dissostichus spp."
    },
    {
      "key": "C644",
      "value": "Certificate of inspection for organic products.  Council Regulation (EC) No 834/2007 on organic production and labelling of organic products and repealing Regulation (EEC) No 2092/91. See also document code Y929"
    },
    {
      "key": "C645",
      "value": "Certificate for military equipment."
    },
    {
      "key": "C647",
      "value": "Confirmation of receipt."
    },
    {
      "key": "C651",
      "value": "Electronic administrative document (e-AD), as referred to in Article 3(1) of Reg. (EC) No 684/2009."
    },
    {
      "key": "C652",
      "value": "Accompanying documents for the carriage of wine products.  COMMISSION REGULATION (EC) No 394/2005, amending Regulation (EC) No 795/2004, laying down detailed rules for the implementation of the single payment scheme provided for in Council Regulation (EC) No 1782/2003.  Establishing common rules for direct support schemes under the common agricultural policy and establishing certain support schemes for farmers, and derogating from Regulation (EC) No 1782/2003."
    },
    {
      "key": "C657",
      "value": "Sanitary certificate for the prevention, control and eradication of certain transmissible spongiform encephalopathies"
    },
    {
      "key": "C658",
      "value": "Fallback Accompanying Document for movements of excise goods under suspension of excise duty (FAD), as referred to in Article 8(1) Reg. (EC) No 684/2009."
    },
    {
      "key": "C659",
      "value": "Prior written declaration."
    },
    {
      "key": "C661",
      "value": "Explicit consent."
    },
    {
      "key": "C662",
      "value": "Import decision."
    },
    {
      "key": "C664",
      "value": "CN22 declaration according to Article 144 of the Regulation (EU) No 2015/2446 empowered by Council Regulation (EU) No 952/2013, Articles 6(2) and 158"
    },
    {
      "key": "C665",
      "value": "CN23 declaration according to Article 144 of the Regulation (EU) No 2015/2446 empowered by Council Regulation (EU) No 952/2013, Articles 6(2) and 158."
    },
    {
      "key": "C666",
      "value": "Certificate issued by the Federal Grain Inspection service (FGIS).  COMMISSION REGULATION (EC) No 1375/2007 on imports of residues from the manufacture of starch from maize from the United States of America.  Note: Certificates report the grade of the grain inspected based on characteristics such as test weight, moisture, cleanliness, and damage.  Certificates are issued for the various grains for which standards exist under the U.S. Grain Standards Act, as amended, and for rice, pulses, and miscellaneous processed commodities covered by Part 68 of the regulations under the Agricultural Marketing Act of 1946, as amended. Please also see document code C668"
    },
    {
      "key": "C667",
      "value": "Laboratory analysis.  COMMISSION REGULATION (EC) No 1375/2007 on imports of residues from the manufacture of starch from maize from the United States of America.  "
    },
    {
      "key": "C668",
      "value": "Certificate issued by the USA wet milling industry in accordance with COMMISSION REGULATION (EC) No 1375/2007 before 7.3.2017 on imports of residues from the manufacture of starch from maize from the United States of America. All goods declared under CN code 2309 90 20  from the USA should be accompanied by a certificate issued by the Federal Grain Inspection Service (FGIS) and a certificate issued by the USA wet milling industry as set out in Annex I of the Regulation. Please also see document code C666"
    },
    {
      "key": "C669",
      "value": "Notification document as mentioned in Regulation (EC) No 1013/2006 (OJ L 190) - Article 4 and Annex IA on shipments of waste. See also document codes C670, C672, Y915, Y923 and 9005"
    },
    {
      "key": "C670",
      "value": "Movement document as mentioned in Regulation (EC) No 1013/2006 (OJ L 190) � Article 4 and Annex IB on shipments of waste. See also document codes C669, 9005 and Y915"
    },
    {
      "key": "C671",
      "value": "Certificate issued by the Canadian Grain Commission (CGC) See also document code C684 and C685"
    },
    {
      "key": "C672",
      "value": "Information document accompanying shipments of waste as mentioned in Regulation (EC) No 1013/2006 (OJ L 190) � Article 18 and Annex VII on shipments of waste. See also document codes C669, C670, Y915, Y923 and 9005"
    },
    {
      "key": "C673",
      "value": "Catch certificate.  COUNCIL REGULATION (EC) No 1005/2008 establishing a Union system to prevent, deter and eliminate illegal, unreported and unregulated fishing. See also Document code Y927"
    },
    {
      "key": "C676",
      "value": "Import/ Export authorisation issued by the competent authorities of the Member States.  Decision 1764/15. This code is to be used for all national facilitations and authorisations listed in Appendix 6, such as codes: CSE, DEP, EPSS, EXW, EXWH, FAS, GGA, LVBI, SIVA, UKCS, as instructed by the DE 1/10 Procedure code completion instructions"
    },
    {
      "key": "C678",
      "value": "Common Health Entry Document for Feed and Food of Non-Animal Origin (CHED-D) (as referred to in point (d) of Article 47(1) of Regulation (EU) 2017/625) and as set out in Part 2, Section D of Annex II to Commission Implementing Regulation (EU) 2019/1715 (OJ L 261))"
    },
    {
      "key": "C679",
      "value": "Attesting Document (seal product), issued by a recognised body in accordance with either -Regulation (EU) No 737/2010 (on condition that the attesting document was issued prior to 18 October 2015) or, COMMISSION IMPLEMENTING REGULATION (EU) 2015/1850, laying down detailed rules for the implementation of Regulation (EC) No 1007/2009 of the European Parliament and of the Council on trade in seal products. See also document codes C680, C683, Y032 and 9118"
    },
    {
      "key": "C680",
      "value": "Written notification of import and document giving evidence where the products were acquired (seal product).  COMMISSION IMPLEMENTING REGULATION (EU) 2015/1850 laying down detailed rules for the implementation of Regulation (EC) No 1007/2009 of the European Parliament and of the Council on trade in seal products. See also codes C679, C683 and 9118"
    },
    {
      "key": "C683",
      "value": "European Union - Attesting document for seal products resulting from hunt by Inuit or other indigenous communities for placing on the Union's market in accordance with Article 3 (1) of Regulation (EC) No 1007/2009 on trade in seal products.  See also codes C679, C680 and 9118"
    },
    {
      "key": "C684",
      "value": "Certificate in accordance with the model set out in the Annex of Regulation (EU) No 2015/949 (OJ L 156, p.2) approving the pre-export checks carried out on certain food by certain third countries as regards the presence of certain mycotoxins.  Certificate in accordance with the model set out in the Annex of Regulation (EU) No 2015/949 (OJ L 156, p.2) approving the pre-export checks carried out on certain food by certain third countries as regards the presence of certain mycotoxins.\nPre-export checks carried out prior to export to the Union by the Canadian Grain Commission, as competent authority, regarding ochratoxin A in wheat and wheat flour listed in Annex I and produced on the territory of Canada are approved.\nThe following pre-export checks carried out prior to export to the Union by the United States Department of Agriculture (USDA), as competent authority, are approved:\nCommission Implementing Regulation (EU) 2017/1269 of 13 July 2017 amending Implementing Regulation (EU) 2015/949 as regards withdrawal of groundnuts (peanuts) from the United States of America from the list of approved pre-export checks as regards aflatoxins \n(b) pre-export checks regarding aflatoxins in almonds listed in Annex I and produced on the territory of the United States\nSee also document code C671 and C685\n"
    },
    {
      "key": "C685",
      "value": "Report containing the results of sampling and analysis performed in accordance with the provisions of Commission Regulation (EC) No 401/2006 of 23 February 2006, or with equivalent requirements, by a laboratory approved for that purpose by the Canadian Grain Commission. See also document codes C671 and C684"
    },
    {
      "key": "C687",
      "value": "Health certificate as mentioned in Annex III of Commission Implementing Decision 2011/884/EU (OJ L 343, 23.12.2011, p. 140). Note: Each consignment of products referred to in Article 1 of the Decision must be accompanied by an analytical report for each lot, and by a health certificate in accordance with the models set out in Annexes III and IV, completed, signed and verified by an authorised representative of the �Entry Exit Inspection and Quarantine Bureau of the People�s Republic of China� (AQSIQ)."
    },
    {
      "key": "C688",
      "value": "Analytical report as mentioned in Annex IV of Commission Implementing Decision 2011/884/EU (OJ L 343, 23.12.2011, p. 140). Note: Each consignment of products referred to in Article 1 of the Decision must be accompanied by an analytical report for each lot, and by a health certificate in accordance with the models set out in Annexes III and IV, completed, signed and verified by an authorised representative of the �Entry Exit Inspection and Quarantine Bureau of the People�s Republic of China� (AQSIQ)."
    },
    {
      "key": "C690",
      "value": "FLEGT import licence for timber.  Council Regulation (EC) No 2173/2005 on the establishment of a FLEGT licensing scheme for imports of timber into the European Union.  Article 4 of Council Regulation (EC) No 2173/2005 prohibits the import of FLEGT timber products from countries which have entered in to a Voluntary Partnership Agreement (VPA) with the EU unless they are covered by a valid FLEGT licence (UK Tariff)."
    },
    {
      "key": "C692",
      "value": "Results of sampling and analysis performed by a USDA approved laboratory carried out in accordance with the provisions of Commission Regulation (EC) No 401/2006 of 23 February 2006."
    },
    {
      "key": "C693",
      "value": "Certificate issued by the USA wet milling industry in accordance with Commission Implementing Regulation (EU) 2017/337."
    },
    {
      "key": "C700",
      "value": "Information sheet INF4"
    },
    {
      "key": "C710",
      "value": "Information sheet INF"
    },
    {
      "key": "C715",
      "value": "Import-One-Stop-Shop (IOSS) number - individual VAT identification number (Art. 369q of Council Directive (EU) 2017/2455)"
    },
    {
      "key": "C990",
      "value": "End use authorisation ships and platforms (Column 8c, Annex A of Delegated Regulation (EU) 2015/2446). "
    },
    {
      "key": "D005",
      "value": "Commercial Invoice within the framework of undertakings containing a signed declaration referring to the Undertaking offered by a particular company and accepted by the European Commission in respect of the terms of sale for the goods concerned (and which therefore exempts that company�s products from the application of Anti-Dumping duty)."
    },
    {
      "key": "D008",
      "value": "Invoice with a signed declaration by a company official declaring that the goods were manufactured by a particular company (whose products do not attract the full (highest rate) of rate of Anti-Dumping duty payable).  COMMISSION IMPLEMENTING REGULATION (EU) 2015/1518 imposing a definitive anti-dumping duty on imports of biodiesel originating in the United States of America following an expiry review pursuant to Article 11(2) of Council Regulation (EC) No 1225/2009.  COMMISSION IMPLEMENTING REGULATION (EU) 2015/1519 imposing definitive countervailing duties on imports of biodiesel originating in the United States of America following an expiry review pursuant to Article 18 of Council Regulation (EC) No 597/2009.  COMMISSION IMPLEMENTING REGULATION (EU) 2016/675 amending Implementing Regulation (EU) 2015/1519 imposing definitive countervailing duties on imports of biodiesel originating in the United States of America following an expiry review pursuant to Article 18 of Council Regulation (EC) No 597/2009.  COMMISSION IMPLEMENTING REGULATION (EU) 2016/676 amending Implementing Regulation (EU) 2015/1518 imposing a definitive anti-dumping duty on imports of biodiesel originating in the United States of America following an expiry review pursuant to Article 11(2) of Council Regulation (EC) No 1225/2009."
    },
    {
      "key": "D017",
      "value": "Commercial invoice within the framework of undertakings and Export Undertaking Certificate containing a signed declaration referring to the Undertaking offered by a particular company in relation to the application of Anti-Dumping duty)."
    },
    {
      "key": "D018",
      "value": "Invoice for transactions which are not exempted from countervailing/anti-dumping duties (Annex VI of Regulation 2017/367; identical to Annex 5 of Regulation 2017/366)."
    },
    {
      "key": "D019",
      "value": "Authorisation to use a Special Procedure within the context of an anti-dumping/countervailing measure, where Article 211(6) of EU Reg. No. 952/2013 applies (Column 8c, Annex A of Delegated Regulation (EU) 2015/2446).  Note: This doc code is only required when the goods attract a positive rate of ADD or countervailing duty. It should be used in addition to document codes C990 or N990."
    },
    {
      "key": "D020",
      "value": "Commercial invoice and mill certificate as defined in EC Regulation 2015/1953. The commercial invoice should be declared using document code N935."
    },
    {
      "key": "D022",
      "value": "Commercial invoice from the manufacturer to the trader bearing a declaration of the manufacturer as specified in Annex 3 of Reg. 2019/2131. This document code is used where a Manufacturer�s declaration for indirect export sale of ceramic tableware and kitchenware originating in the People�s Republic of China is required. The commercial invoice from the trader to the importer should be declared using document code N935."
    },
    {
      "key": "E017",
      "value": "Export certificate issued by the competent authorities of a third country."
    },
    {
      "key": "I004",
      "value": "Surveillance document issued by the competent authorities of a Member State valid throughout the EU.  Regulation (EC) 670/2016 Introducing prior Union surveillance of imports of certain iron and steel products."
    },
    {
      "key": "L001",
      "value": "Import licence AGRIM.  COMMISSION DELEGATED REGULATION (EU) 2016/1237 supplementing Regulation (EU) No 1308/2013 of the European Parliament and of the Council with regard to the rules for applying the system of import and export licences and supplementing Regulation (EU) No 1306/2013 of the European Parliament and of the Council with regard to the rules on the release and forfeit of securities lodged for such licences, amending Commission Regulations (EC) No 2535/2001, (EC) No 1342/2003, (EC) No 2336/2003, (EC) No 951/2006, (EC) No 341/2007 and (EC) No 382/2008 and repealing Commission Regulations (EC) No 2390/98, (EC) No 1345/2005, (EC) No 376/2008 and (EC) No 507/2008. See also document code Y036"
    },
    {
      "key": "L079",
      "value": "Textile products: import licence.  "
    },
    {
      "key": "L081",
      "value": "Certificate of analysis (Commission Implementing Regulation (EU) 2020/1988) Article 9 repealing Regulation (EC) No 1064/2009) for malting barley from third countries. See also L082"
    },
    {
      "key": "L082",
      "value": "Certificate of conformity (Commission Implementing Regulation (EU) 2020/1988) Article 9 repealing  Regulation (EC) No 1064/2009) for malting barley from third countries. See also L081"
    },
    {
      "key": "L100",
      "value": "Import licence \"controlled substances\" (ozone), issued by the Commission.  REGULATION (EC) No 1005/2009 OF THE EUROPEAN PARLIAMENT AND OF THE COUNCIL on substances that deplete the ozone layer. See also document code L136 and Y902"
    },
    {
      "key": "L116",
      "value": "Kimberley Process Certificate.  COUNCIL REGULATION (EC) No 2368/2002 implementing the Kimberley Process certification scheme for the international trade in rough diamonds."
    },
    {
      "key": "L135",
      "value": "Import authorisation (precursors) issued by the competent authorities of the Member State where the importer is established."
    },
    {
      "key": "L136",
      "value": "Goods, containing, or relying on, ozone-depleting substances, to be used as feedstock or for laboratory and analytical uses.  REGULATION (EC) No 1005/2009 OF THE EUROPEAN PARLIAMENT AND OF THE COUNCIL on substances that deplete the ozone layer. See also document code L100 and Y902"
    },
    {
      "key": "N002",
      "value": "Certificate of conformity with the European Union marketing standards for fresh fruit and vegetables."
    },
    {
      "key": "N003",
      "value": "Certificate of quality."
    },
    {
      "key": "N018",
      "value": "ATR certificate."
    },
    {
      "key": "N235",
      "value": "Container list."
    },
    {
      "key": "N271",
      "value": "Packing list/Goods manifest/Goods Manifest where not available on an electronic inventory. Note: Please refer to the instructions in Appendix 2A DE-11 for completion requirements when N271 is a mandatory document."
    },
    {
      "key": "N325",
      "value": "Proforma invoice."
    },
    {
      "key": "N337",
      "value": "Summary declaration for temporary storage."
    },
    {
      "key": "N355",
      "value": "Entry summary declaration."
    },
    {
      "key": "N380",
      "value": "Commercial invoice."
    },
    {
      "key": "N703",
      "value": "House waybill."
    },
    {
      "key": "N704",
      "value": "Master bill of lading."
    },
    {
      "key": "N705",
      "value": "Bill of lading."
    },
    {
      "key": "N710",
      "value": "Maritime manifest (T1)"
    },
    {
      "key": "N714",
      "value": "House bill of lading."
    },
    {
      "key": "N720",
      "value": "Consignment note CIM (T1)"
    },
    {
      "key": "N722",
      "value": "Road list � SMGS."
    },
    {
      "key": "N730",
      "value": "Road consignment note."
    },
    {
      "key": "N740",
      "value": "Air waybill (T1)"
    },
    {
      "key": "N741",
      "value": "Master airwaybill."
    },
    {
      "key": "N750",
      "value": "Movement by post including parcel post."
    },
    {
      "key": "N760",
      "value": "Multimodal/combined transport document."
    },
    {
      "key": "N785",
      "value": "Cargo manifest."
    },
    {
      "key": "N787",
      "value": "Bordereau (cargo load list)."
    },
    {
      "key": "N820",
      "value": "Transit declaration \"T\"."
    },
    {
      "key": "N821",
      "value": "External Union transit declaration/ common transit, T1."
    },
    {
      "key": "N822",
      "value": "Internal Union transit declaration T2."
    },
    {
      "key": "N825",
      "value": "T2L document."
    },
    {
      "key": "N851",
      "value": "Phytosanitary certificate."
    },
    {
      "key": "N852",
      "value": "Analysis and health certificate. Please also see C678"
    },
    {
      "key": "N853",
      "value": "Common Health Entry Document for Products (CHED-P) (as set out in Part 2, Section B of Annex II to Commission Implementing Regulation (EU) 2019/1715 (OJ L 261)) for products referred to in point (b) of Article 47(1) of Regulation (EU) 2017/625)  "
    },
    {
      "key": "N864",
      "value": "Invoice declaration or origin declaration made out by any exporter on the invoice or any other commercial document (excluding the Bill of Lading) for originating goods where the total value exceeds �6000 (value limit deleted from new TARIC description)."
    },
    {
      "key": "N865",
      "value": "Certificate of origin �Form A�."
    },
    {
      "key": "N933",
      "value": "Cargo declaration (arrival)."
    },
    {
      "key": "N934",
      "value": "Declaration of particulars relating to customs value D.V.1. (to be completed on request)                                                "
    },
    {
      "key": "N935",
      "value": "The invoice on the basis of which the customs value of the goods is declared."
    },
    {
      "key": "N941",
      "value": "Embargo permit."
    },
    {
      "key": "N951",
      "value": "TIF form."
    },
    {
      "key": "N952",
      "value": "TIR Carnet."
    },
    {
      "key": "N954",
      "value": "Movement certificate EUR.1 See also:  Y019 where the document shows that the goods originate in\nIceland; Y020 where the document shows that the goods originate in\nNorway; and\nY021 where the document shows that goods originate in the EEA."
    },
    {
      "key": "N955",
      "value": "ATA carnet."
    },
    {
      "key": "N990",
      "value": "EUS - Authorisation for the use of end use procedure (Column 8c, Annex A of Delegated Regulation (EU) 2015/2446)."
    },
    {
      "key": "U003",
      "value": "Certificate of origin meeting the conditions laid-down in article 57 of Regulation (EU) No. 2015/2447  "
    },
    {
      "key": "U004",
      "value": "Certificate of origin for imports of products subject to special non-preferential import arrangements into the European Union established in accordance with Article 57 of Commission Implementing Regulation (EU) 2015/2447."
    },
    {
      "key": "U005",
      "value": "Certificate of designation of origin issued by the competent authorities.  "
    },
    {
      "key": "U031",
      "value": "Certificate EUR 1. bearing the endorsement \"Derogation - Commission Implementing Decision 2014/461/EU\" or \"D?rogation - D?cision d'ex?cution 2014/461/UE de la Commission\".  Certificate EUR 1 bearing the endorsement �DEROGATION- DECISION Nr 2001/936/EC� as regards the rules of origin for prepared and preserved shrimps and prawns from Greenland (notified under document number C(2001) 4648) Paper Tariff. See also document code U073"
    },
    {
      "key": "U045",
      "value": "Movement Certificate EUR-MED See also:  Y019 where the declaration shows that the goods originate in\nIceland; Y020 where the declaration shows that the goods originate in\nNorway; and Y021 where the document shows that goods originate in the EEA."
    },
    {
      "key": "U048",
      "value": "Invoice for EUR-MED. EUR-MED declaration of preferential origin on an invoice or other commercial document bearing as appropriate an original signature or approval number of the exporter in a Pan-Euro- Mediterranean Country See also:  Y019 where the declaration shows that the goods originate in\nIceland; Y020 where the declaration shows that the goods originate in\nNorway; and\nY021 where the document shows that goods originate in the EEA."
    },
    {
      "key": "U052",
      "value": "Certificate of origin Form A bearing the endorsement \"Derogation - Implementing Regulation (EU) 2019/620\"."
    },
    {
      "key": "U058",
      "value": "Certificate EUR 1. bearing the endorsement \"DEROGATION-DECISION 2011/122/EU\" or \"D?rogation - D?cision 2011/122/UE\"."
    },
    {
      "key": "U059",
      "value": "Origin declaration containing the following statement in English: \"Derogation - Annex II(a) of Protocol concerning the definition of �originating products� and methods of administrative cooperation \"."
    },
    {
      "key": "U062",
      "value": "Origin quota and alternatives to the product specific rules of origin in Annex 5-A of CETA of Council Decision (EU) 2017/37 (OJ L11).  "
    },
    {
      "key": "U063",
      "value": "Proof of origin containing the following statement in English: \"Derogation - Annex II(a) of Protocol 3 - name of the Development Zone or industrial area and authorisation number granted by the competent authorities of Jordan."
    },
    {
      "key": "U067",
      "value": "Certificate EUR 1.  bearing the endorsement \"Derogation-Decision No 1/2012 of the ESA-EU Customs Cooperation Committee of 29/11/2012\" or \"D?rogation - D?cision No 1/2012 du Comit? de Coop?ration Douani?re AfOA-UE du 29/11/2012\"."
    },
    {
      "key": "U068",
      "value": "Proof of origin containing the following statement in English: \"Product originating in accordance with Appendix 2A of Annex II\"."
    },
    {
      "key": "U069",
      "value": "Proof of origin containing the following statement in English: �Product originating in accordance with Appendix 5 of Annex II�."
    },
    {
      "key": "U071",
      "value": "Proof of origin containing the following statement: �Product originating in accordance with Appendix 2A of Annex II (Concerning the Definition of the Concept of �Originating Products� and Methods of Administrative Cooperation)� (OJ L346, 15.12.2012)."
    },
    {
      "key": "U072",
      "value": "Certificate of origin Form A bearing the endorsement \"Derogation-Implementing Regulation (EU) 2019/561\"."
    },
    {
      "key": "U073",
      "value": "Origin declaration containing the following statement \"Derogation - Commission Implementing Decision 2014/461/EU\" or \"D?rogation - D?cision d'ex?cution 2014/461/UE de la Commission\" as regards the rules of origin for prepared and preserved shrimps and prawns from Greenland. See also document code U031"
    },
    {
      "key": "U074",
      "value": "Certificate of origin for imports of agricultural products into the European Union, used in the framework of tariff quotas according to Article 13 (rice), Regulation (EU) 2020/1988. As per the model set out in Part B of Annex II issued by a competent authority of Bangladesh"
    },
    {
      "key": "U088",
      "value": "Origin declaration stating European Union origin, in the context of the Canada-European Union Comprehensive Economic and Trade Agreement (CETA)"
    },
    {
      "key": "U090",
      "value": "Movement certificate EUR. 1 - Movement certificate EUR-MED (under the condition that in box 7 the remark \"no cumulation applied\" is marked with a cross) stating European Union origin, in the context of the agreement between the European Union and the Swiss Confederation (codification/key: U090)."
    },
    {
      "key": "U091",
      "value": "Invoice declaration - Invoice declaration EUR-MED (under the condition the declaration contains the remark \"no cumulation applied\"), stating European Union origin, in the context of the agreement between the European Union and the Swiss Confederation."
    },
    {
      "key": "U095",
      "value": "Certificate of origin Form A bearing the endorsement \"Derogation � Commission Implementing Regulation (EU) No 2018/348\"."
    },
    {
      "key": "U096",
      "value": "Certificate EUR.1 bearing the endorsement \"Derogation - [Commission Implementing Decision (EU) 2015/164]\" or \"D?rogation - [D?cision d'ex?cution (UE) 2015/164 de la Commission]\"."
    },
    {
      "key": "U097",
      "value": "Certificate EUR.1 bearing the endorsement \"Derogation - Decision No 1/2015 of the CARIFORUM-EU Special Committee on Customs Cooperation and Trade Facilitation of 10 March 2015', 'D?rogation - D?cision no 1/2015 du Comit? sp?cial de coop?ration douani?re et de facilitation des ?changes CARIFORUM-UE due 10 mars 2015' or Excepci?n - Decisi?n no 1/2015 del Comit? Especial CARIFORUM-UE de Coperaci?n Aduanera y Facilitacion del Comercio del 10 de marzo 2015'."
    },
    {
      "key": "U099",
      "value": "Certificate EUR.1 bearing the endorsement \"Derogation-Regulation (EU) 2017/882\"."
    },
    {
      "key": "U100",
      "value": "Certificate EUR 1. bearing the endorsement �Derogation � Decision No 1/2017 of the CARIFORUM-EU Special Committee on Customs Cooperation and Trade facilitation of 7 July 2017�; �D?rogation � D?cision no 1/2017 du Comit? sp?cial de coop?ration douani?re et de facilitation des ?changes CARIFORUM-UE du 7 juillet 2017� or �Excepci?n � Decisi?n no 1/2017 del Comit? Especial CARIFORUM-UE de Cooperaci?n Aduanera y Facilitaci?n del Comercio del 7 de julio 2017�."
    },
    {
      "key": "U110",
      "value": "Statement on Origin "
    },
    {
      "key": "U111",
      "value": "Statement on Origin for multiple shipments of identical products "
    },
    {
      "key": "U112",
      "value": "Importer�s knowledge "
    },
    {
      "key": "U113",
      "value": "Statement on origin made out by a Registered Exporter in the framework of Overseas Association Decision (OAD) for a total value of originating products consigned not exceeding �10,000"
    },
    {
      "key": "U114",
      "value": "Statement on Origin made out by a Registered Exporter in the framework of OAD for a total value of originating products consigned exceeding �10,000."
    },
    {
      "key": "U115",
      "value": "Statement on origin made out by a Non-Registered Exporter in the framework of OAD for a total value of originating products consigned not exceeding �10,000."
    },
    {
      "key": "U161",
      "value": "Invoice declaration or origin declaration made out by any exporter on an invoice or any other commercial document within the framework of GSP for a total value of originating products not exceeding �6000, according to Art. 75 of Reg. 2015/2447."
    },
    {
      "key": "U162",
      "value": "Invoice declaration or origin declaration made out on invoice by any exporter or any other commercial document neither in the framework of GSP nor EUR-MED for a total value of originating products not exceeding �6000"
    },
    {
      "key": "U163",
      "value": "Invoice declaration or origin declaration EUR-MED made out by any exporter on invoice or any other commercial document for a total value of originating products not exceeding �6000."
    },
    {
      "key": "U164",
      "value": "Statement on origin made out by a Registered Exporter (REX) in the framework of GSP for a total value of originating products consigned not exceeding �6000. When declaring U164 an additional document code, C100, must also be declared in DE 2/3"
    },
    {
      "key": "U165",
      "value": "Statement on origin made out by a Registered Exporter (REX) in the framework of GSP for a total value of originating products consigned exceeding �6000. When declaring U165 an additional document code, C100, must also be declared in DE 2/3"
    },
    {
      "key": "U166",
      "value": "Statement on origin made out by a non-registered Exporter in the framework of GSP for a total value of originating products consigned not exceeding �6000."
    },
    {
      "key": "U167",
      "value": "Statement on origin made out by a non-registered EU re-consignor in the framework of GSP for a total value of originating products of the initial consignment to be split exceeding �6000.  "
    },
    {
      "key": "U168",
      "value": "Replacement origin declaration or replacement invoice declaration made out by an approved exporter where the total value of originating product in the initial consignment to be split does not exceed the applicable value threshold, according to Art. 69(2a) of Reg. 2015/2447."
    },
    {
      "key": "U169",
      "value": "Replacement origin declaration or replacement invoice declaration made out by an approved exporter where the total value of originating product in the initial consignment to be split exceeds the applicable value threshold, according to Art. 69(2a) of Reg. 2015/2447."
    },
    {
      "key": "U170",
      "value": "Replacement origin declaration or replacement invoice declaration made out by any re-consignor where the total value of originating product in the initial consignment to be split does not exceed the applicable value threshold, according to Art. 69(2b) of Reg. 2015/2447."
    },
    {
      "key": "U171",
      "value": "Replacement origin declaration or replacement invoice declaration made out by any re-consignor where the total value of originating product in the initial consignment to be split exceeds the applicable value threshold, according to Art. 69(2c) of Reg. 2015/2447."
    },
    {
      "key": "U176",
      "value": "Certificate EUR1 bearing the endorsement \"Derogation � Decision No 1/2020 of the ESA-EU Customs Cooperation Committee of 5 May 2020 \" or \"D?rogation � D?cision no 1/2020 du comit? de coop?ration douani?re AfOA-UE du 14 Mai 20209 \" Snoek (barracouta), salted."
    },
    {
      "key": "U177",
      "value": "Proof of origin containing the following statement in English: \"Derogation � Annex B (a) of Protocol Concerning the definition of the concept of �originating products� and methods of administrative cooperation of the EU-Singapore FTA\". Proof of origin for EU and The Republic of Singapore FTA (Offical Journal L294 14/11/2019  "
    },
    {
      "key": "U500",
      "value": "EUR.2 form.  "
    },
    {
      "key": "Y001",
      "value": "Wholly obtained in Lebanon and transported directly from that country to the Union.  Certificate of Origin to support a claim to tariff quota on olive oil imported from Lebanon, declaring that the oil originated in and was transported direct from that country."
    },
    {
      "key": "Y003",
      "value": "Wholly obtained in Tunisia and transported directly from that country to the Union.  Designation of Origin Certificate to support a claim to tariff quota on other sparkling wine and other wine of fresh grapes imported from Tunisia, declaring that the wine originated in and was transported direct from that country."
    },
    {
      "key": "Y006",
      "value": "Stamp (at beginning/end of each piece) and directly transported. Non-preferential Tariff Quota for silk or cotton handloom products. See also document codes A015 and Y007"
    },
    {
      "key": "Y007",
      "value": "Seal (fixed to each piece) and directly transported. Non-preferential Tariff Quota for silk or cotton handloom products. See also document codes A015 and Y006"
    },
    {
      "key": "Y008",
      "value": "Transported directly from Turkey to the Union."
    },
    {
      "key": "Y013",
      "value": "Insertion of one of the following endorsements in the \"Remarks\" column of a goods movement certificate.  Regulation (EEC) No 1518/76 (OJ L 169/37):  Taxe sp?ciale ? l'exportation appliqu?e S?rlig udf?rselsafgift opkr?vet Sonderausfuhrabgabe erhoben Special export charge collected Applicata tassa speciale all'esportazione Bijzondere uitvoerheffing voldaan. Note: Regulation (EEC) no. 1518/76 covers interim Agreement between the European Union and the People's Democratic Republic of Algeria and concerning the import into the Union of bran and sharps originating in Algeria."
    },
    {
      "key": "Y015",
      "value": "The rough diamonds are contained in tamper-resistant containers, and the seals applied at export by the participant (Kimberley process) are not broken.  COUNCIL REGULATION (EC) No 2368/2002 implementing the Kimberley Process certification scheme for the international trade in rough diamonds."
    },
    {
      "key": "Y017",
      "value": "Wholly obtained in Jordan and transported directly from that country to the Union."
    },
    {
      "key": "Y019",
      "value": "Request for preferential treatment for Iceland."
    },
    {
      "key": "Y020",
      "value": "Request for preferential treatment for Norway.  Proof of Preferential Origin (Form EUR1, EUR-MED or declaration of preferential origin on an invoice or other commercial document) declaring that the goods originate in Norway.  "
    },
    {
      "key": "Y021",
      "value": "Request for EEA preferential treatment.  Proof of Preferential Origin (Form EUR1, EUR-MED or declaration of preferential origin on an invoice or other commercial document) declaring that the goods originate in the EEA-European Economic Area.  Document code Y021 must be used to support a claim to a preferential rate of duty where the proof shows country or origin as EEA (rather than Norway, Iceland or Liechtenstein)."
    },
    {
      "key": "Y022",
      "value": "Consignor / exporter (AEO certificate number)."
    },
    {
      "key": "Y023",
      "value": "Importer/Consignee (AEO certificate number)."
    },
    {
      "key": "Y024",
      "value": "Declarant (AEO certificate number)."
    },
    {
      "key": "Y025",
      "value": "Representative (AEO certificate number)."
    },
    {
      "key": "Y026",
      "value": "Principal (AEO certificate number)."
    },
    {
      "key": "Y027",
      "value": "Warehousekeeper (AEO certificate number)."
    },
    {
      "key": "Y028",
      "value": "Carrier (AEO certificate number)."
    },
    {
      "key": "Y029",
      "value": "Other authorised economic operator (AEO certificate number)."
    },
    {
      "key": "Y031",
      "value": "This certificate code may be used to indicate that shipments are coming from or going to an Authorised Economic Operator (AEO) in a third country with which the European Union (EU) has concluded a mutual recognition agreement regarding AEO programmes.  "
    },
    {
      "key": "Y032",
      "value": "Other goods than those seal products mentioned in Regulation (EU) 2015/1850 (OJ L 271) laying down detailed rules for the implementation of Regulation (EC) No 1007/2009 of the European Parliament and of the Council on trade in seal products. See also documents codes C679 and 9118"
    },
    {
      "key": "Y033",
      "value": "Derogation from import prohibition by virtue of Article 4(2) of Council Regulation (EU) 2017/1509 concerning restrictive measures against the Democratic People's Republic of Korea and repealing Regulation (EC) No 329/2007."
    },
    {
      "key": "Y036",
      "value": "The declared goods are exempted from the presentation of the concerned licence by virtue of Article 3 (1) points a, b, d and e and (2) of Commission Delegated Regulation (EU) 2016/1237 (OJ L 206). See also document codes L001 and X001"
    },
    {
      "key": "Y038",
      "value": "Derogation from import prohibition by virtue of Article 14 of Council Regulation (EU) 2017/1509 concerning restrictive measures against the Democratic People's Republic of Korea and repealing Regulation (EC) No 329/2007."
    },
    {
      "key": "Y043",
      "value": "Reimportation of textile products following an outward processing operation, in accordance with Regulation (EC) No 32/2000 - ANNEX II."
    },
    {
      "key": "Y046",
      "value": "Goods not covered by the provisions of Regulation (EU) No 284/2011, referring to kitchenware falling under the provisions of Regulation (EU) 284/2011, originating in or consigned from the People�s Republic of China and Hong Kong Special Administrative Region, China. See also document code: C060"
    },
    {
      "key": "Y053",
      "value": "Goods not concerned by labelling requirements on fluorinated greenhouse gases as referred to Article 12, paragraph 1 of Regulation (EU) No 517/2014. See also document codes C057, C079, C082, Y054, Y950 and Y951"
    },
    {
      "key": "Y054",
      "value": "Goods labelled according to the provisions of Article 12, paragraph 1 of Regulation (EU) No 517/2014 on fluorinated greenhouse gases. See also document codes C057, C079, C082, Y053, Y950 and Y951"
    },
    {
      "key": "Y057",
      "value": "Goods not requiring the presentation of a FLEGT import licence for timber.  Decision 0284/14."
    },
    {
      "key": "Y058",
      "value": "Exemption by virtue of Article 7 of Commission Delegated Regulation 2019/2122 (Goods which form part of passengers personal luggage and are intended for personal consumption or use)  "
    },
    {
      "key": "Y062",
      "value": "Products which are not containing, consisting of or produced from rice (Commission Implementing Decision 2011/884/EU (OJ L 343, 23.12.2011, p. 140).)."
    },
    {
      "key": "Y063",
      "value": "Goods not consigned from China.  (Commission Implementing Decision 2011/884/EU (OJ L 343, 23.12.2011, p. 140).)."
    },
    {
      "key": "Y066",
      "value": "Products which are not containing or consisting of betel leaves (�Piper betle�).  Decision 0088/14."
    },
    {
      "key": "Y069",
      "value": "Goods not consigned from Iran.  Council Regulation (EU) No 267/2012 Concerning Restrictive Measures Against Iran and Repealing Regulations (EU) No 961/2010."
    },
    {
      "key": "Y070",
      "value": "Exemption from the requirement of presenting FLEGT licence by virtue of Article 4.3 of Council Regulation (EC) No 2173/2005 for imports of timber into the European Union."
    },
    {
      "key": "Y072",
      "value": "Goods with EU origin returning from Andorra, according to the relevant EU legislation.  Decision 0275/07."
    },
    {
      "key": "Y073",
      "value": "Goods with EU origin returning from Switzerland, according to the relevant EU legislation.  Decision 0275/07."
    },
    {
      "key": "Y074",
      "value": "Goods with EU origin returning from Faroe Islands, according to the relevant EU legislation.  Decision 0275/07."
    },
    {
      "key": "Y075",
      "value": "Goods with EU origin returning from Greenland, according to the relevant EU legislation.  Decision 0275/07."
    },
    {
      "key": "Y076",
      "value": "Goods with EU origin returning from Iceland, according to the relevant EU legislation.  Decision 0275/07."
    },
    {
      "key": "Y077",
      "value": "Goods with EU origin returning from Liechtenstein, according to the relevant EU legislation.  Decision 0275/07."
    },
    {
      "key": "Y078",
      "value": "Goods with EU origin returning from Norway, according to the relevant EU legislation.  Decision 0275/07."
    },
    {
      "key": "Y079",
      "value": "Goods with EU origin returning from San Marino, according to the relevant EU legislation.  Decision 0275/07."
    },
    {
      "key": "Y084",
      "value": "Derogation from import prohibition by virtue of Article 16i (1) of Council Regulation (EU) 2017/1509 concerning restrictive measures against the Democratic People's Republic of Korea and repealing Regulation (EC) No 329/2007."
    },
    {
      "key": "Y085",
      "value": "Goods imported in the framework of 'Autonomous trade measures'."
    },
    {
      "key": "Y086",
      "value": "Request for preferential treatment for Albania."
    },
    {
      "key": "Y087",
      "value": "Request for preferential treatment for Bosnia and Herzegovina."
    },
    {
      "key": "Y088",
      "value": "Request for preferential treatment for Montenegro."
    },
    {
      "key": "Y089",
      "value": "Request for preferential treatment for the former Yugoslav Republic of Macedonia."
    },
    {
      "key": "Y090",
      "value": "Request for preferential treatment for the customs territory of Kosovo."
    },
    {
      "key": "Y091",
      "value": "Request for preferential treatment for Serbia."
    },
    {
      "key": "Y100",
      "value": "Special entries on the import licence AGRIM."
    },
    {
      "key": "Y105",
      "value": "Generic exemption from REACH authorisation (Art. 56 of Regulation (EC) No 1907/2006) Registration, Evaluation, Authorisation and Restriction of Chemicals (REACH) requires authorisations to be issued for the importation, exportation and placing on the home market of potentially harmful chemical substances.\nThis document code is used to state that the goods are exempted from the authorisation requirements of Regulation (EC) No 1907/2006 See also document codes C073, Y109 and Y115"
    },
    {
      "key": "Y109",
      "value": "Specific exemption from REACH authorisation (exempted (categories of) use listed in Annex XIV of Regulation (EC) No 2006/1907) Registration, Evaluation, Authorisation and Restriction of Chemicals (REACH) requires authorisations to be issued for the importation, exportation and placing on the home market of potentially harmful chemical substances.\nThis document code is used to state that the goods have a specific exemption from the authorisation requirements of Regulation (EC) No 1907/2006 See also document codes C073, Y105 and Y115"
    },
    {
      "key": "Y115",
      "value": "Exemption from Authorization (Title VII) Article 2 point 5 and 8 of Regulation (EC) No 1907/2006 (REACH) Registration, Evaluation, Authorisation and Restriction of Chemicals (REACH) requires authorisations to be issued for the importation, exportation and placing on the home market of potentially harmful chemical substances.\nThis document code is used to state that the goods have a specific exemption from the authorisation requirements of Regulation (EC) No 1907/2006 See also document codes C073, Y105 and Y109"
    },
    {
      "key": "Y116",
      "value": "Exemption from the provisions of Article 254 of Regulation (EU) No 952/2013 by virtue of the annual Combined Nomenclature regulation: Part one - Preliminary Provisions - Section I general rules - C.�� General rules applicable both to nomenclature and to duties - 4.� Goods eligible for favourable tariff treatment by reason of their end-use"
    },
    {
      "key": "Y200",
      "value": "Belgium - Continental shelf or Exclusive Economic Zone (Regulation (EU) 2019/1131 establishing a customs tool, OJ L 179, p. 12) This document code must be declared on all: \n� import declarations made for goods arriving from the continental shelf and \n� export declarations for goods being sent to the continental shelf."
    },
    {
      "key": "Y201",
      "value": "Bulgaria - Continental shelf or Exclusive Economic Zone (Regulation (EU) 2019/1131 establishing a customs tool, OJ L 179, p. 12) This document code must be declared on all: \n� import declarations made for goods arriving from the continental shelf and \n� export declarations for goods being sent to the continental shelf."
    },
    {
      "key": "Y202",
      "value": "Denmark - Continental shelf or Exclusive Economic Zone (Regulation (EU) 2019/1131 establishing a customs tool, OJ L 179, p. 12) This document code must be declared on all: \n� import declarations made for goods arriving from the continental shelf and \n� export declarations for goods being sent to the continental shelf."
    },
    {
      "key": "Y203",
      "value": "Germany - Continental shelf or Exclusive Economic Zone (Regulation (EU) 2019/1131 establishing a customs tool, OJ L 179, p. 12) This document code must be declared on all: \n� import declarations made for goods arriving from the continental shelf and \n� export declarations for goods being sent to the continental shelf."
    },
    {
      "key": "Y204",
      "value": "Estonia - Continental shelf or Exclusive Economic Zone (Regulation (EU) 2019/1131 establishing a customs tool, OJ L 179, p. 12) This document code must be declared on all: � import declarations made for goods arriving from the continental shelf and  � export declarations for goods being sent to the continental shelf."
    },
    {
      "key": "Y205",
      "value": "Ireland - Continental shelf or Exclusive Economic Zone (Regulation (EU) 2019/1131 establishing a customs tool, OJ L 179, p. 12) This document code must be declared on all: \n� import declarations made for goods arriving from the continental shelf and \n� export declarations for goods being sent to the continental shelf."
    },
    {
      "key": "Y206",
      "value": "Greece - Continental shelf or Exclusive Economic Zone (Regulation (EU) 2019/1131 establishing a customs tool, OJ L 179, p. 12) This document code must be declared on all: � import declarations made for goods arriving from the continental shelf and � export declarations for goods being sent to the continental shelf."
    },
    {
      "key": "Y207",
      "value": "Spain - Continental shelf or Exclusive Economic Zone (Regulation (EU) 2019/1131 establishing a customs tool, OJ L 179, p. 12) This document code must be declared on all: \n� import declarations made for goods arriving from the continental shelf and \n� export declarations for goods being sent to the continental shelf."
    },
    {
      "key": "Y208",
      "value": "France - Continental shelf or Exclusive Economic Zone (Regulation (EU) 2019/1131 establishing a customs tool, OJ L 179, p. 12) This document code must be declared on all: \n� import declarations made for goods arriving from the continental shelf and \n� export declarations for goods being sent to the continental shelf."
    },
    {
      "key": "Y209",
      "value": "Croatia - Continental shelf or Exclusive Economic Zone (Regulation (EU) 2019/1131 establishing a customs tool, OJ L 179, p. 12) This document code must be declared on all: � import declarations made for goods arriving from the continental shelf and � export declarations for goods being sent to the continental shelf."
    },
    {
      "key": "Y210",
      "value": "Italy - Continental shelf or Exclusive Economic Zone (Regulation (EU) 2019/1131 establishing a customs tool, OJ L 179, p. 12) This document code must be declared on all: \n� import declarations made for goods arriving from the continental shelf and \n� export declarations for goods being sent to the continental shelf."
    },
    {
      "key": "Y211",
      "value": "Cyprus - Continental shelf or Exclusive Economic Zone (Regulation (EU) 2019/1131 establishing a customs tool, OJ L 179, p. 12) This document code must be declared on all: \n� import declarations made for goods arriving from the continental shelf and \n� export declarations for goods being sent to the continental shelf."
    },
    {
      "key": "Y212",
      "value": "Latvia - Continental shelf or Exclusive Economic Zone (Regulation (EU) 2019/1131 establishing a customs tool, OJ L 179, p. 12) This document code must be declared on all: \n� import declarations made for goods arriving from the continental shelf and \n� export declarations for goods being sent to the continental shelf."
    },
    {
      "key": "Y213",
      "value": "Lithuania - Continental shelf or Exclusive Economic Zone (Regulation (EU) 2019/1131 establishing a customs tool, OJ L 179, p. 12) This document code must be declared on all: \n� import declarations made for goods arriving from the continental shelf and \n� export declarations for goods being sent to the continental shelf."
    },
    {
      "key": "Y214",
      "value": "Malta - Continental shelf or Exclusive Economic Zone (Regulation (EU) 2019/1131 establishing a customs tool, OJ L 179, p. 12) This document code must be declared on all: \n� import declarations made for goods arriving from the continental shelf and \n� export declarations for goods being sent to the continental shelf."
    },
    {
      "key": "Y215",
      "value": "The Netherlands - Continental shelf or Exclusive Economic Zone (Regulation (EU) 2019/1131 establishing a customs tool, OJ L 179, p. 12) This document code must be declared on all: \n� import declarations made for goods arriving from the continental shelf and  \n� export declarations for goods being sent to the continental shelf."
    },
    {
      "key": "Y216",
      "value": "Poland - Continental shelf or Exclusive Economic Zone (Regulation (EU) 2019/1131 establishing a customs tool, OJ L 179, p. 12) This document code must be declared on all: \n� import declarations made for goods arriving from the continental shelf and \n� export declarations for goods being sent to the continental shelf."
    },
    {
      "key": "Y217",
      "value": "Portugal - Continental shelf or Exclusive Economic Zone (Regulation (EU) 2019/1131 establishing a customs tool, OJ L 179, p. 12) This document code must be declared on all: \n� import declarations made for goods arriving from the continental shelf and \n� export declarations for goods being sent to the continental shelf."
    },
    {
      "key": "Y218",
      "value": "Romania - Continental shelf or Exclusive Economic Zone (Regulation (EU) 2019/1131 establishing a customs tool, OJ L 179, p. 12) This document code must be declared on all: \n� import declarations made for goods arriving from the continental shelf and  \n� export declarations for goods being sent to the continental shelf."
    },
    {
      "key": "Y219",
      "value": "Slovenia - Continental shelf or Exclusive Economic Zone (Regulation (EU) 2019/1131 establishing a customs tool, OJ L 179, p. 12) This document code must be declared on all: \n� import declarations made for goods arriving from the continental shelf and \n� export declarations for goods being sent to the continental shelf."
    },
    {
      "key": "Y220",
      "value": "Finland - Continental shelf or Exclusive Economic Zone (Regulation (EU) 2019/1131 establishing a customs tool, OJ L 179, p. 12) This document code must be declared on all: \n� import declarations made for goods arriving from the continental shelf and \n� export declarations for goods being sent to the continental shelf."
    },
    {
      "key": "Y221",
      "value": "Sweden - Continental shelf or Exclusive Economic Zone (Regulation (EU) 2019/1131 establishing a customs tool, OJ L 179, p. 12) This document code must be declared on all: \n� import declarations made for goods arriving from the continental shelf and \n� export declarations for goods being sent to the continental shelf."
    },
    {
      "key": "Y222",
      "value": "United Kingdom - Continental shelf or Exclusive Economic Zone (Regulation (EU) 2019/1131 establishing a customs tool, OJ L 179, p. 12) This document code must be declared on all: \n� import declarations made for goods arriving from the continental shelf and \n� export declarations for goods being sent to the continental shelf."
    },
    {
      "key": "Y223",
      "value": "Exemption from safeguard measure by virtue of Art. 2 of Reg. (EU) 2019/67 Exemption from safeguard measure on the importation of Indica rice originating in Cambodia, Myanmar/ Burma"
    },
    {
      "key": "Y800",
      "value": "Goods not consigned from Bangladesh.  Decision 0088/14."
    },
    {
      "key": "Y900",
      "value": "Declared goods do not belong to the Washington Convention (CITES) Commission Reg 160/2017 amending Council Reg (EC) No 338/97 on the protection of species of wild fauna and flora by regulating trade therein. See also Document Codes C400, C635 and C638"
    },
    {
      "key": "Y902",
      "value": "Goods other than those described in the OZ footnotes linked to the measure.  REGULATION (EC) No 1005/2009 OF THE EUROPEAN PARLIAMENT AND OF THE COUNCIL on substances that deplete the ozone layer. See also document codes E013, L100 and L136"
    },
    {
      "key": "Y904",
      "value": "Goods other than those described in the TR footnotes linked to the measure.  Commission Implementing Regulation (EU) No 775/2014 of 16 July 2014 amending Council Regulation (EC) No 1236/2005 concerning trade in certain goods which could be used for capital punishment, torture or other cruel, inhuman or degrading treatment or punishment. See also C064, C068, E990, Y906, Y907 and 9106"
    },
    {
      "key": "Y908",
      "value": "Export to the following territories of Member States (Greenland, New Caledonia and Dependencies, French Polynesia, French Southern and Antarctic Territories, Wallis and Futuna Islands, Mayotte, St Pierre and Miquelon, B?singen), provided that the goods are used by an authority in charge of law enforcement in both the country or territory of destination and the metropolitan part of the Member State to which that territory belongs."
    },
    {
      "key": "Y910",
      "value": "Bigeye tuna taken by seiners or baitboats and intended mainly for the canning industry in the areas of application of the Agreement for the establishment of the Indian Ocean Tuna Commission (IOTC Agreement) and the ICCAT Convention. COUNCIL REGULATION (EC) No 1984/2003 establishing a system of statistical registration in the Union concerning bluefin tuna and swordfish and bigeye tuna."
    },
    {
      "key": "Y920",
      "value": "Goods other than those described in the footnotes linked to the measure Decision 1764/15."
    },
    {
      "key": "Y921",
      "value": "Goods exempted from the prohibition.  COUNCIL REGULATION (EU) No 509/2012 amending Regulation (EU) No 36/2012 concerning restrictive measures in view of the situation in Syria."
    },
    {
      "key": "Y922",
      "value": "Other than cats and dogs fur as mentioned by Regulation (EC) No 1523/2007 (OJ L 343) banning the placing on the market and the import to, or export from, the Union of cat and dog fur, and products containing such fur (Text with EEA relevance)."
    },
    {
      "key": "Y923",
      "value": "Product not subjected to the provisions of Regulation (EC) No 1013/2006 (OJ L 190) on shipments of waste. See also document codes C669, C670, C672, Y915 and 9005"
    },
    {
      "key": "Y924",
      "value": "Goods not concerned by Regulation (EU) 2017/852.  Goods other than metallic mercury as mentioned by Regulation (EC) No 1102/2008 on the banning of exports of metallic mercury and certain mercury compounds and mixtures and the safe storage of metallic mercury."
    },
    {
      "key": "Y926",
      "value": "Goods not concerned by import prohibition on fluorinated greenhouse gases."
    },
    {
      "key": "Y927",
      "value": "The declared goods are not concerned by Council Regulation (EC) No. 1005/2008 establishing a Union system to prevent, deter and eliminate illegal, unreported and unregulated fishing, amending Regulations (EEC) No 2847/93, (EC) No 1936/2001 and (EC) No 601/2004 and repealing Regulations (EC) No 1093/94 and (EC) No 1447/1999. See also document code C673"
    },
    {
      "key": "Y928",
      "value": "The declared goods are not concerned by Commission Implementing Regulation (EU) 2019/1787 amending Implementing Regulation (EU) 2016/6 imposing special conditions governing the import of feed and food originating in or consigned from Japan following the accident at the Fukushima nuclear power station "
    },
    {
      "key": "Y929",
      "value": "Goods not concerned by Regulation (EC) No 834/2007 (organic products) Council Regulation (EC) No 834/2007 on organic production and labelling of organic products and repealing Regulation (EEC) No 2092/91. See also document code C644"
    },
    {
      "key": "Y930",
      "value": "The declared goods are not concerned by Commission Implementing Regulation (EU) 2021/632 as regards the labelling of beef and beef products"
    },
    {
      "key": "Y931",
      "value": "Goods benefitting from dereogation to veterinary controls according to Article 3 of Commission Delegated Regulation (EU) 2021/630 as regards the labelling of beef and beef products"
    },
    {
      "key": "Y932",
      "value": "Goods benefitting from a derogation to CITES controls according to Article 7(3) of Council Regulation (EC) No 338/97 on the protection of species of wild fauna and flora by regulating trade therein.  "
    },
    {
      "key": "Y937",
      "value": "The declared goods are not concerned by Commission Implementing Regulation (EU) 2019/1793 repealing Commission Regulation (EC) No 669/2009 as regards the increased level of official controls on imports of certain feed and food of non-animal origin See also document code Y978"
    },
    {
      "key": "Y942",
      "value": "The declared goods are not concerned by Commission Implementing Regulation (EU) 2016/1141 adopting a list of invasive alien species of Union concern pursuant to Regulation (EU) No 1143/2014 of the European Parliament and of the Council."
    },
    {
      "key": "Y944",
      "value": "Goods other than those described in Annex VI (Petroleum products) of Reg. (EU) 2017/1509 concerning restrictive measures against the Democratic People's Republic of Korea.  COUNCIL REGULATION (EU) 2017/1509 concerning restrictive measures against the Democratic People's Republic of Korea and repealing Regulation No 329/2007."
    },
    {
      "key": "Y945",
      "value": "Travellers' personal effects or goods of a non-commercial nature for travellers' personal use contained in their luggage (Art 10.2 of Regulation (EU) 2017/1509) entitled to exemption from prohibition on goods from Democratic People's Republic of Korea."
    },
    {
      "key": "Y948",
      "value": "Goods other than those described in Annex VIII (Luxury goods) of Reg. (EU) 2017/1509 exemption on import and export prohibition on luxury goods from/to Democratic People's Republic of Korea."
    },
    {
      "key": "Y949",
      "value": "Goods other than those described in the footnotes linked to the measure (Reg 267/2012).  Council Regulation (EU) No 267/2012 Concerning Restrictive Measures Against Iran."
    },
    {
      "key": "Y950",
      "value": "Goods other than pre-charged equipment with hydroflurocarbons (not pre-charged with hydrofluorocarbons) or Article 14.1 of Regulation No 517/2014 does not apply. See also document codes C057, C079, C082, Y053, Y054 and Y951"
    },
    {
      "key": "Y951",
      "value": "Exemptions from the Reduction of the quantity of hydrofluorocarbons placed on the market by virtue of Article 15.2 of Regulation (EU) No 517/2014 See also document codes C057, C079, C082, Y053, Y054 and Y950"
    },
    {
      "key": "Y957",
      "value": "Goods other than those described in the MG footnotes linked to the measure (Annex II, Part V of Reg. (EU) 2017/1509)."
    },
    {
      "key": "Y958",
      "value": "Goods other than those described in Annex IV (Gold, titanium, vanadium ore, rare-earth minerals) of Reg. (EU) 2017/1509."
    },
    {
      "key": "Y959",
      "value": "Goods other than those described in Annex V (Coal, iron and iron ore) of Reg. (EU) 2017/1509."
    },
    {
      "key": "Y960",
      "value": "Goods other than those described in Annex VII (Copper, nickel, silver and zinc) of Reg. (EU) 2017/1509."
    },
    {
      "key": "Y961",
      "value": "Goods other than those described in Annex IX (Gold, precious metals and diamonds) of Reg. (EU) 2017/1509."
    },
    {
      "key": "Y962",
      "value": "Goods other than those described in Annex X (Statues) of Reg. (EU) 2017/1509."
    },
    {
      "key": "Y963",
      "value": "Goods other than those described in the MG footnotes linked to the measure (Annex II, Part IV of Reg. (EU) 2017/1509)."
    },
    {
      "key": "Y964",
      "value": "Goods other than those described in Annex XIa (Seafood) of Reg. (EU) 2017/1509."
    },
    {
      "key": "Y965",
      "value": "Goods other than those described in Annex XIb (Lead and lead ore) of Reg. (EU) 2017/1509."
    },
    {
      "key": "Y966",
      "value": "Goods other than those described in the MG footnotes linked to the measure (Missile Technology Control Regime list - Annex III of Reg. (EU) 267/2012)."
    },
    {
      "key": "Y968",
      "value": "Goods not exceeding a sales price of 50 � per litre"
    },
    {
      "key": "Y969",
      "value": "Mercury-added products essential for civil protection and military uses; or intended for research, calibration of instrumentation or for use as reference standard (Article 5 (2) of Regulation (EU) 2017/852)."
    },
    {
      "key": "Y970",
      "value": "Goods other than those described in the MG footnotes linked to the measure (Annex II, Part VI of Reg. (EU) 2017/1509) concerning restrictive measures against the Democratic People's Republic of Korea and repealing Regulation (EC) No 329/2007."
    },
    {
      "key": "Y971",
      "value": "Goods other than those described in the MG footnotes linked to the measure (Annex II, Part VIII of Reg. (EU) 2017/1509) concerning restrictive measures against the Democratic People's Republic of Korea and repealing Regulation (EC) No 329/2007."
    },
    {
      "key": "Y978",
      "value": "Exemption by virtue of Article 1(3) of Regulation (EU) 2019/1793 repealing Commission Regulation (EC) No 669/2009 as regards the increased level of official controls on imports of certain feed and food of non-animal origin See also document code Y937"
    },
    {
      "key": "Y980",
      "value": "Goods benefitting from derogation to veterinary controls according to Article 4 of Commission Delegated Regulation (EU) 2019/2126"
    },
    {
      "key": "108C",
      "value": "To declare an HMRC C108 form for Temporary Admissions Oral Declarations on a C21i only. See Additional Procedure Codes (DE�1/11) 50A, 50M and 51P"
    },
    {
      "key": "1207",
      "value": "Providing specific authority for an agent (declarant/representative) to use an importers deferment account."
    },
    {
      "key": "1246",
      "value": "Form C&E1246 (Returned Goods Relief duplicate lists) (Notice 236)"
    },
    {
      "key": "1314",
      "value": "Form C1314 (Returned Goods Relief claim form) (Notice 236)"
    },
    {
      "key": "1421",
      "value": "Form C1421 � Importing inherited goods free of duty and VAT (Notice 368)."
    },
    {
      "key": "1434",
      "value": "Claims to duty and VAT relief claimed on Form DD1434 (used by US visiting Forces)."
    },
    {
      "key": "185C",
      "value": "Form 185C: Claim to Visiting Forces Relief for goods removed from a customs warehouse"
    },
    {
      "key": "2CVF",
      "value": "Claims to duty/ VAT relief for the importation of personal property imported by other NATO visiting forces personnel on Form C2. (Not for use by US visiting forces)"
    },
    {
      "key": "426C",
      "value": "Form C426: Request to release goods with a claim to Diplomatic Privilege"
    },
    {
      "key": "517C",
      "value": "Form C517: Import VAT apportionment form. See also�Appendix 4:�DE�2/2 Additional Information (AI)�Statement Code VAT04"
    },
    {
      "key": "9001",
      "value": "Declaration of preferential origin on an invoice or other commercial document bearing as appropriate an original signature or approval number of the exporter\nSee also:\n� Y019 where the declaration shows that the goods originate in Iceland;\n� Y020 where the declaration shows that the goods originate in Norway; and\n� Y021 where the document shows that goods originate in the EEA.\n\n\n\n"
    },
    {
      "key": "9004",
      "value": "Certificates of origin for steel quotas."
    },
    {
      "key": "9005",
      "value": "All other import documents (including Department of Health) licences, permits or certificates other than those specifically identified by other document codes.\nSee also document codes C669, C670, C672, Y915 and Y923.\nWhen declaring a waiver status code (XX or XW as appropriate),a write off amount must be included in the seventh and eighth components of DE 2/3 with an amount of �0� after a recognised measurement unit (for example, �KGM0�). "
    },
    {
      "key": "9100",
      "value": "Firearms: Open Individual Licence.\nFirearms: Specific Individual Licence.\nNuclear Materials: Open Individual Licence.\nNuclear Materials: Specific Individual Licence.\nWhen declaring a waiver status code (XX or XW as appropriate),a write off amount must be included in the seventh and eighth components of DE 2/3 with an amount of �0� after a recognised measurement unit (for example, �KGM0�). "
    },
    {
      "key": "9101",
      "value": "Chemical weapons � pre-cursor chemicals.\nWhen declaring a waiver status code (XX or XW as appropriate),a write off amount must be included in the seventh and eighth components of DE 2/3 with an amount of �0� after a recognised measurement unit (for example, �KGM0�). "
    },
    {
      "key": "9102",
      "value": "Standard Individual Transhipment Licence.\nOpen general Transhipment Licence.\nWhen declaring a waiver status code (XX or XW as appropriate),a write off amount must be included in the seventh and eighth components of DE 2/3 with an amount of �0� after a recognised measurement unit (for example, �KGM0�). \n"
    },
    {
      "key": "9103",
      "value": "Detonation resistance test (DRT)\nHSE certificate of exemption.\n"
    },
    {
      "key": "9111",
      "value": "Home Office open individual licence for drugs precursor chemicals."
    },
    {
      "key": "9112",
      "value": "Drugs Precursor Chemicals Individual Licence."
    },
    {
      "key": "9113",
      "value": "Controlled Drugs Individual Licence."
    },
    {
      "key": "9114",
      "value": "Controlled Drugs Open Individual Licence."
    },
    {
      "key": "9115",
      "value": "Quarantine Release Certificate."
    },
    {
      "key": "9116",
      "value": "Rabies import licence."
    },
    {
      "key": "9117",
      "value": "FERA letter of authority."
    },
    {
      "key": "9118",
      "value": "Import permit for harp and hooded seal skins.\nSee also codes C679, C680, C683 and Y032"
    },
    {
      "key": "9119",
      "value": "Letter headed licence for importation of hares."
    },
    {
      "key": "9120",
      "value": "Importation of animal pathogens Licence under the Importation of Animal pathogens Order 1980 (IAPO)."
    },
    {
      "key": "9121",
      "value": "DEFRA�or Animal Health import licence/authorisation for products of animal origin."
    },
    {
      "key": "920C",
      "value": "Declaration for imported decorations and awards. Relief from import Duty and VAT.\nNote: Form C920 may be required to qualify for the relief."
    },
    {
      "key": "9300",
      "value": "(T2) Air Manifest\nAir Simplified procedure."
    },
    {
      "key": "941C",
      "value": "Claims to duty/ VAT relief for the importation of vehicles/means of transport imported by visiting forces personnel using Form C&E 941."
    },
    {
      "key": "955D",
      "value": "When codes M or N are inserted, a deposit slip (form C&E955) must be attached to the declaration.\nWhen code R is used, deposit slip (form C&E955D) must be attached.\nFailure to attach forms C&E955 and C&E955D could result in a delay in any future repayment."
    },
    {
      "key": "9578",
      "value": "Form C578 � undertaking to produce Form D.V. 1/invoice/CAP�Licence/Preference certificate within 14 days."
    },
    {
      "key": "999L",
      "value": "Goods qualify for a document waiver or exemption from the measure shown against a specific commodity code.\n*Only applicable for use on GB import/export declarations.\nNot applicable for use on NI declarations\nEffective until 30.09.23"
    },
    {
      "key": "9AID",
      "value": "Evidence required by Procedure or Additional Procedure Code (DE�1/10 and�DE�1/11) instructions for claiming relief from all charges except VAT."
    },
    {
      "key": "9AIE",
      "value": "Evidence required by Procedure or Additional Procedure Code (DE�1/10 and�DE�1/11) instructions, relief from Excise Duty."
    },
    {
      "key": "9AIV",
      "value": "Evidence required by Procedure or Additional Procedure Code (DE�1/10 and�DE�1/11) instructions or claiming relief from VAT."
    },
    {
      "key": "9CPD",
      "value": "CPD Carnet: Only required where the Carnet requires endorsement by the Customs authority �"
    },
    {
      "key": "9ESA",
      "value": "Certificate to evidence that the goods being imported are for use by the European Space Agency (ESA) or Astrium Ltd for use on INTELSAT projects.\nNote: This code is only for use with�DE�1/11 (Additional Procedure Code) 1ES."
    },
    {
      "key": "9WKS",
      "value": "Worksheet to support calculation of the customs value and/or revenue calculations (for example: C&E 1154 for Outward Processing Relief).\nManual calculations required if the goods have been invoiced in more than one currency or a fixed rate of exchange has been stipulated in the contract of sale.\nIf a fixed rate of exchange has been used this is also to be declared on the attached document and rate declared in�DE�4/15"
    }
  ];

  export default documentsProducedAdditionalCategoryCode;